import { CargoApi } from '../../../../api/Purchase/Cargo'
import AddCargo from '../../../../components/Purchasing/Cargo/AddCargo/AddCargo'
import useActions from '../../../../elements/Hooks/useActions'
import useModalData, { MODAL_TYPE_EDIT, MODAL_TYPE_NEW } from '../../../../elements/Hooks/useModalData'
import useTitle from '../../../../elements/Hooks/useTitle'
import { get, isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'

AddCargoCont.propTypes = {}

function AddCargoCont(props) {
  const key = get(props.match, 'params.key')

  const {
    visible,
    modalType,
    object: cargo,
    setObject: setCargo,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
    fetching,
    fetchObject: fetch,
  } = useModalData(
    CargoApi.create,
    CargoApi.update,
    CargoApi.remove,
    undefined,
    key,
    CargoApi.read,
    (key) => {
      props.history.replace({
        pathname: `/purchasing/cargo/${key}/update`,
      })
    },
    () => {
      props.history.replace({
        pathname: `/purchasing/cargo/list/`,
      })
    }
  )

  const [currentRoute, setCurrentRoute] = useState({})
  useEffect(() => {
    return () => {
      if (!!cargo && !isEmpty(cargo) && !isEmpty(cargo.routes)) {
        console.log('in', cargo)
        const remainingRoutes = cargo.routes.filter((r) => r.hasFreightBooking === false)
        if (remainingRoutes.length <= 0) {
          setCurrentRoute(cargo.routes.sort((r) => r.index)[cargo.routes.length])
        } else {
          setCurrentRoute(remainingRoutes.sort((r) => r.index)[0])
        }
      } else {
        console.log('out', !!cargo, !isEmpty(cargo))
      }
    }
  }, [cargo, fetching])

  const { actions, fetchingActions, fetchActions, submittingOperation, submitOperation, handleActions } = useActions(
    'cargo',
    cargo,
    setCargo,
    CargoApi.operation,
    fetch
  )

  const type = key ? MODAL_TYPE_EDIT : MODAL_TYPE_NEW
  const isNew = type === MODAL_TYPE_NEW
  useTitle(cargo.code === undefined ? `Create New Cargo Order` : `${cargo.code} Cargo Order`)

  const isUpdatable = isNew ? true : actions.find((a) => a.key === 'update')
  const isConfirmed = cargo.status === 'Confirmed'

  return (
    <AddCargo
      {...{
        type,
        visible,
        modalType,
        cargo,
        submitting,
        submit,
        removing,
        isConfirmed,
        remove,
        formRef,
        onShow,
        onCancel,
        update,
        isNew,
        actions,
        fetchingActions,
        fetchActions,
        submittingOperation,
        submitOperation,
        handleActions,
        fetching,
        fetch,
        currentRoute,
        isUpdatable,
      }}
    />
  )
}

export default withRouter(AddCargoCont)
